import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Provider, useStore } from "@faire/retailer-visitor-shared/stores/domain/OpeningOrderIncentivesContextStore";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Storage } from "@faire/web--source/common/Storage";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import getTime from "date-fns/getTime";
import React, { useEffect } from "react";
import { setIntervalIfPossible } from "@faire/retailer/lib/async-functions/setIntervalIfPossible";
var isDrivenFromEmailStorageKey = "OpeningOrderIncentivesIsDrivenFromEmail";
var INTERVAL_MS = 60 * 1000;
var OpeningOrderIncentivesProviderBase = function(param) {
    var children = param.children;
    var _useStore = _sliced_to_array(useStore([]), 2), _ = _useStore[0], setStore = _useStore[1];
    useEffect(function() {
        if (getCurrentPath().searchParams.get("oeln") === "opening-order-incentives-marketing") {
            Storage.session.setItem(isDrivenFromEmailStorageKey, "true");
            trackEvent("opening-order-incentives/marketing-email/driven-from");
        }
    }, []);
    useEffect(function() {
        var timer = function() {
            setStore({
                currentTime: getTime(new Date())
            });
        };
        var _interval = setIntervalIfPossible(timer, INTERVAL_MS);
        return function() {
            return clearInterval(_interval);
        };
    }, [
        setStore
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export var OpeningOrderIncentivesProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(OpeningOrderIncentivesProviderBase, {
            children: children
        })
    });
};
